import { ASSETS, ESCAPECORE, PSYCHOACTIVE, STORY } from "@/data/content";
import { t } from "@/data/texts";
import { img } from "@/data/images";
import { Reveal, Worms } from "@/components/effects/Effects";

function Block({ kicker, title, body }) {
  return (
    <Reveal className="border-l-2 border-[#4a0404] pl-6 py-2">
      {kicker && <p className="text-xs tracking-[0.35em] text-nv uppercase mb-3">{kicker}</p>}
      <h2 className="font-head text-3xl sm:text-4xl text-neutral-100 mb-5 vhs-glitch">{title}</h2>
      <p className="text-base sm:text-lg text-neutral-400 leading-relaxed whitespace-pre-line">{body}</p>
    </Reveal>
  );
}

export default function AboutNarrative() {
  return (
    <section id="o-hre" className="relative bg-[#060505] border-b border-white/10" data-testid="about-section">
      <Worms count={2} />
      <div className="max-w-7xl mx-auto px-5 py-20 lg:py-28 grid lg:grid-cols-2 gap-14 lg:gap-20">
        {/* Sticky image column */}
        <div className="relative">
          <div className="lg:sticky lg:top-28">
            <div className="relative border border-white/10 overflow-hidden">
              <img
                src={img("hero2", ASSETS.hero2)}
                alt="Interiér domu HUBERT"
                className="w-full h-[340px] sm:h-[520px] object-cover"
              />
            </div>
            <p className="mt-5 font-head text-xl text-neutral-300 leading-relaxed vhs-glitch">
              „{t("story.quote", STORY.quote)}"
            </p>
          </div>
        </div>

        {/* Scrolling narrative */}
        <div className="flex flex-col gap-16">
          <Block kicker="Psychoactive Escapecore" title={t("escapecore.title", ESCAPECORE.title)} body={t("escapecore.body", ESCAPECORE.body)} />
          <Block kicker="Práce s podvědomím" title={t("psychoactive.title", PSYCHOACTIVE.title)} body={t("psychoactive.body", PSYCHOACTIVE.body)} />
          <Block kicker="Příběh" title={t("story.title", STORY.title)} body={t("story.body", STORY.body)} />
        </div>
      </div>
    </section>
  );
}
